import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LeadsService } from 'src/app/_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { MiscService } from '../../_service/misc.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
@Component({
  selector: 'app-add-edit-zone',
  templateUrl: './add-edit-zone.component.html',
  styleUrls: ['./add-edit-zone.component.css']
})
export class AddEditZoneComponent implements OnInit {
  zoneForm: FormGroup; submitted = false;
  loading: boolean = false; zone_id: any = '';
  circles_copy = []; circles = [];
  constructor(public router: Router, private formBuilder: FormBuilder, public miscapi: MiscService, private sharedapi: SharedService, public dialogRef: MatDialogRef<AddEditZoneComponent>, @Inject(MAT_DIALOG_DATA) public data: MatDialog, public leadapi: LeadsService) {

    this.zoneForm = this.formBuilder.group({
      'circle_id': [null, Validators.required],
      'zone_name': [null, Validators.required]
    });

    if (data) {
      this.zone_id = data;
      this.patchPinCodeData(this.zone_id);
    }
  }

  get f() { return this.zoneForm.controls; }

  async createZone() {
    this.submitted = true;
    this.loading = true;
    if (this.zoneForm.invalid) {
      this.loading = false;
      return;
    }
    this.zoneForm.value.id = parseInt(this.zone_id);
    await this.miscapi.addEditZone(this.zoneForm.value).subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      if (data.status) {
        this.sharedapi.presentToast(data.msg);
        this.router.navigate(['/master-zone-list'])
          .then(() => {
            window.location.reload();
          });
        this.CloseModal();
        this.zoneForm.reset();
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  ngOnInit(): void {
    this.getcircle();
  }

  async getcircle() {
    await this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async patchPinCodeData(zone_id) {
    await this.miscapi.getZoneEditData(this.zone_id).subscribe((response: any) => {
      if (response.status) {
        this.zoneForm.patchValue({
          'circle_id': response.data.circle_id,
          'zone_name': response.data.zone_name
        });
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }


  CloseModal(): void {
    this.dialogRef.close();
  }
}
